import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/venue.template.htm';
import 'dhtmlxMessage';
import Model from '../models/venues.model.ts';
import MapView from "views/map_location.view.ts";
import OrganizationsOptions from "views/organizations_options.view.ts";
import VenuesOptions from "views/venues_options.view.ts";
import i18n  from "l10n";
import croppie from '../../libs/croppie/js/croppie.js';

export default GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	Model : null,
	id: null,
    editable: null,
    fields: null,
    userData: null,
    privilegeLevel: null,
    back: false,
	initialize: function (options) {
	    this.superInitialize();
	    var self = this;
	    this.id = options ? options.id : null;
	    this.userData = options.data;
	    this.privilegeLevel = this.privilegeLevelToNumber( this.userData.privilegeLevel);

        if(this.id)
        {
            this.editable = true;
            this.model = new Model({ id : this.id });
            this.model.fetch({
                success: function(response)
                {
                    self.render();
                    self.showMapBasic();
                },
                error: function(response, xhr, status)
                {
                     //console.info("error error");
                }
            });

        }
        else
        {
            this.editable = false;
            this.model = new Model();
            this.render();
            self.showMapBasic();
        }

        this.fields =
        {
            name: [this.isEmpty],
            address: [this.isEmpty, this.maxLengthNumber],
        };



	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		var data = $.extend(this.model.toJSON(), { editable: this.editable });

		this.photoUrl = data.imagePath;
        this.hasImage = data.imagePath != null;

        this.$el.html(this.template(data));

        this.initTools(data);
	},
	events: {
	    //"click #location-button": "search",
        "click #submitBtn": "clickOnSubmit",
        "click #submitBack": "clickOnSubmitBack",
        "click #delete": "clickOnDelete",
        "click #cancel": "goBack",
        "click #reset": "clickOnReset",
        "change .to-validation input": "validateIt",
        "keyup .to-validation input": "validateIt",
        "keyup #description textarea": "validateDescription",
        "input .areaInput": "updateMaximumNumberOfCustomers",
        "click #uploadPhoto": "upload_photo",
        "click #removePhoto": "remove_photo",
        "click #previewPhoto": "preview_photo"
	},
	updateMaximumNumberOfCustomers: _.debounce(function(e) {
	    var area = $("#store_area").find("input").val();
	    var perPerson = $("#one_person_per_square_meters").find("input").val();

	    var calculated = Handlebars.helpers.calcMaxNumberOfPeople(area, perPerson);

	    $("#calculatedMaxNumberOfPeople").text(calculated);
	}, 300),
	validateDescription: function()
	{
	   this.characterLeft("#description");
	},
	checkDescription: function() {
        var has_error = false;
        var description = $("#description").find("textarea").val().trim();

        if (description == "") {
            this.setError($("#description"), i18n.t("organization.empty_field"));
            has_error = true;
        }

        return has_error;

    },
	search: function()
	{
	    this.mapView.searchForAddress();
	},
	showMapBasic: function(e)
    	{
            if(this.mapView == null)
                this.mapView = new MapView();

            this.mapView.renderMap();
    	},
	clickOnSubmitBack: function(e)
    {
        var self = this;

        this.back = true;
        this.mapView.saveMarkerClicked();

        $.when(this.cropPhoto()).then(function(imgSrc) {
            if(!imgSrc && self.hasImage && self.photoUrl) {
                //console.error("Image remained the same");
                self.photoUrl = self.model.get("imagePath");
            }else if(imgSrc) {
                self.photoUrl = imgSrc;
                //console.error("Image changed");
            }else if(!imgSrc && !self.hasImage) {
                self.photoUrl = null;
                //console.error("no image at all");
            }else if(!imgSrc && self.hasImage && !self.photoUrl) {
                self.photoUrl = null;
                //console.error("image deleted");
            }else {
                //should never occur
                console.error("NONE OF THE ABOVE");
            }

            self.clickOnSubmit(null);

        });
    },
	clickOnSubmit: function(e)
    {
        var self = this;

        var has_error = this.validateFields(this.fields);
        //console.info("has_error: " + has_error);

        has_error = this.organizationsOptions.isTheDataWrong() || has_error;
        has_error = this.validateDescription() || has_error;
        var has_error3 = this.checkDescription();

        if( $("#latitude").find("input").val().trim() == 0 && $("#longitude").find("input").val().trim() == 0)
        {
            this.setError($("#address"), i18n.t("venue.select_pin"));
            has_error = true;
        }
        else
        {
          this.clearError($("#address"));
        }

        if(!has_error && !has_error3)
        {
            this.model.set("name", $("#name").find("input").val().trim());
            this.model.set("englishName", $("#englishName").find("input").val().trim());
            this.model.set("address", $("#address").find("input").val().trim());
            this.model.set("lat",$("#latitude").find("input").val().trim());
            this.model.set("lon", $("#longitude").find("input").val().trim());
            this.model.set("description", $("#description").find("textarea").val().trim());

            var area = parseInt($("#store_area").find("input").val().trim());
            var perPerson = parseInt($("#one_person_per_square_meters").find("input").val().trim());

            this.model.set("storeArea", isNaN(area) ? null : area);
            this.model.set("squareDistancePerPerson", isNaN(perPerson) ? null : perPerson);

            var phone = $("#phone").find("input").val().trim().length > 0 ? $("#phone").find("input").val().trim() : null;
            var website = $("#website").find("input").val().trim().length > 0 ? $("#website").find("input").val().trim() : null;

            this.model.set("phone", phone);
            this.model.set("website", website);

            this.model.set("imagePath", this.photoUrl);

            this.model.set("orgId", 1);
            if(!this.editable)
            {
                var orgId = this.organizationsOptions.getData();
                this.model.set("orgId", orgId);
            }

            this.showActionProgressBar();

            $.when(window.ping()).then(function(resp) {
                $.ajaxSetup({
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                    }
                });

                self.model.save(null, {
                    success: function(response)
                    {
                        self.hideActionProgressBar();
                        if(self.editable)
                        {
                            $.notify(i18n.t("venue.venue_updated"), { position:"top center", className: "success"});

                            if(self.back)
                                self.goBack();
                            self.back = false;
                        }
                        else
                        {
                            $.notify(i18n.t("venue.venue_added"), { position:"top center", className: "success" });
                            self.goBack();
                        }
                    },
                    error: function(response)
                    {
                        self.hideActionProgressBar();
                        //console.info("error error");
                    }
                });
            });


        }
        else
        {
            $.notify(
                i18n.t("account.check_errors"),
                { position:"top center", className: "error" }
            );
        }
    },
    clickOnDelete: function(e)
    {
        var self = this;
        var removing_model = this.model;
        var venue_name = removing_model.get("name");

        dhtmlx.confirm({
            type: "confirm",
            text: i18n.t("venue.confirm_delete_venue") +" \"" + venue_name + "\" ?",
            ok: "Delete",
            cancel: "Cancel",
            callback: function (result) {
                //if yes -> delete the venue and return to venues page
                if (result) {
                    self.showActionProgressBar();
                    removing_model.destroy( {
                        success: function(response) {
                           self.hideActionProgressBar();

                           $.notify(i18n.t("venue.venue") + " \"" +  venue_name + "\" "+ i18n.t("organization.was_deleted"), { position:"top center", className: "success" });
                           self.goBack();
                        }
                    });
                }
            }
        });
    },
    clickOnReset: function(e)
    {
        $("#name").find("input").val("");
        $("#address").find("input").val("");
        $("#description").find("textarea").val("");
    },
    validateIt: function(event)
    {
        var element = $(event.currentTarget).parent();
        if(!element.hasClass("to-validation"))
            element = element.parent();

        var field = {};
        if(this.fields[element.prop("id")])
        {
            field[element.prop("id")] = this.fields[element.prop("id")]
            //console.info(field);
            this.validateFields( field );
        }
    },
    initTools: function(data)
    {
        var params =
        {
            userPrivilege: this.privilegeLevel,
            editable: this.editable
        };

        this.organizationsOptions = new OrganizationsOptions($.extend(params, { orgId: data.orgId } ));
        this.organizationsOptions.load();

    },
    upload_photo: function(e) {
        var self = this;
        $("input[name=file]").change(function () {
            if (this.files && this.files[0]) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    self.photoUrl = e.target.result;
                    $('#venue_img').show();
                    $('#actionsP').show();
                    if(!self.croppie)
                        self.croppie = $('#venue_img').croppie({
                            url: self.photoUrl,
                            enableExif: true,
                            viewport: {
                                width: 256,
                                height: 256,
                                type: 'circle'
                            },
                            enforceBoundary: false //Restricts zoom so image cannot be smaller than viewport
                        });
                };

                reader.readAsDataURL(this.files[0]);

                $('#uploadPhoto').hide();
            }
        });
    },
    cropPhoto: function() {
        return this.croppie ? this.croppie.croppie('result') : null;
    },
    preview_photo: function() {
        var self = this;
        if (this.croppie) {
            this.croppie.croppie('result').then(function(imgSrc) {
                self.popup(imgSrc);
            });
        }
        else
        {
            this.popup("." + this.model.get("imagePath"));
        }

    },
    popup: function(imgSrc) {
        dhtmlx.alert({
            type: "alert",
            text: "<div style='background-color:#e1e1e1;' class='imageQueuePreview'><img style='float:inherit; margin:0 auto; padding:10px 0;' src='"+ imgSrc +"'/></div>"
        });
    },
    remove_photo: function()
    {
        $('#actionsP').hide();
        $('#uploadPhoto').show();
        this.photoUrl = null;

        $('#venue_img').croppie('destroy');
        $('#venue_img').html("");
        this.croppie = null;
    }
});

